import type { FilterItem } from '@ctw/shared/components/filter-bar/filter-bar-types';
import { partition } from 'lodash-es';

export interface PartitionedFilters {
  /** Filters rendered as standalone controls in the toolbar. */
  promoted: Array<FilterItem>;
  /** Non-promoted filters rendered inside the Filters modal. */
  menu: Array<FilterItem>;
  /** Menu filters rendered as titled option-group sections (checkbox/select). */
  optionGroups: Array<FilterItem>;
  /** Menu filters rendered as toggles under "Additional Options" (tag). */
  toggles: Array<FilterItem>;
}

export function partitionFilters(filters: Array<FilterItem>): PartitionedFilters {
  const [promoted, menu] = partition(filters, (filter) => filter.promoted === true);
  const [toggles, optionGroups] = partition(menu, (filter) => filter.type === 'tag');
  return { promoted, menu, optionGroups, toggles };
}
